import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { BaseBillingDialog } from '../base-billing-dialog';
import { TabItem } from '@components/tabs/tab-item.interface';
import { BillingService } from '@features/billing/billing.service';
import { ToastService } from '@core/state/toast/toast.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { DialogRef } from '@components/dialog/dialog-ref';
import { BillingDetailRequest } from '@core/models/billing/billing-detail-request';
import { pickClass } from '@core/utils/object';

@Component({
    selector: 'ihd-dialog-payment-method',
    templateUrl: 'payment-method.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class DialogPaymentMethodComponent extends BaseBillingDialog implements OnInit, OnDestroy, AfterViewInit {
    public config: any;
    public tabItems: TabItem[];

    constructor(
        billingService: BillingService,
        cdr: ChangeDetectorRef,
        toastService: ToastService,
        sanitizer: DomSanitizer,
        translateService: TranslateService,
        private dialogRef: DialogRef<DialogPaymentMethodComponent>
    ) {
        super(
            billingService,
            toastService,
            sanitizer,
            translateService,
            cdr
        );
        this.config = dialogRef.containerInstance.config;
        this.tabItems = [
            {
                label: 'Billing.Details.Payment.Title',
                active: true,
            },
        ];
    }

    ngOnInit() {
        this.initStripe();
    }

    ngOnDestroy() {
        this.destroy();
    }

    ngAfterViewInit() {
        this.isFormReady = true;

        // Wait for Stripe and UI to both be ready
        if (this.isStripeReady) {
            this.initStripeForm();
        } else if (!this.isIHDSubscription) {
            // if stripe hasn't initalized yet, its time to retry
            this.retryInit();
        }
    }

    closeDialog() {
        this.dialogRef.close();
    }

    /**
     * Tokenise the payment method details and update billing details.
     * @returns {Promise<void>}
     */
    async submit() {
        this.isLoading = true;
        this.cdr.markForCheck();

        const billingDetails: BillingDetailRequest = pickClass(
            this.config.billingDetails || {},
            BillingDetailRequest
        );
        const stripeResponse = await this.stripe.createToken(this.cardNumber, {
            name: `${billingDetails.first_name} ${billingDetails.last_name}`,
            address_line1: billingDetails.address.line1,
            address_line2: billingDetails.address.line2,
            address_city: billingDetails.address.city,
            address_state: billingDetails.address.state,
            address_zip: billingDetails.address.postal_code,
            address_country: billingDetails.address.country,
        });

        // If stripe success then process token
        if (stripeResponse && stripeResponse.token) {
            billingDetails.source = stripeResponse.token.id;
        }

        this.processStripeResponse(
            stripeResponse,
            billingDetails,
            this.dialogRef
        );
    }
}
